const HTTP_RE = /^https?:\/\//i;

export function normalizeInstagram(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const value = input.trim().replace(/^@/, '');
  if (HTTP_RE.test(value)) return value;
  return `https://instagram.com/${value}`;
}

export function normalizeFacebook(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const value = input.trim().replace(/^@/, '');
  if (HTTP_RE.test(value)) return value;
  return `https://facebook.com/${value}`;
}

export function normalizeWebsite(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const value = input.trim();
  if (HTTP_RE.test(value)) return value;
  return `https://${value}`;
}
